import React from 'react';
import { Clock, ArrowUpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useSubscriptionContext } from '@/contexts/SubscriptionContext';

export const TrialWarningBanner: React.FC = () => {
  const { subscription } = useSubscriptionContext();

  if (!subscription || subscription.status !== 'trialing') {
    return null;
  }

  // Calculate days remaining
  const now = new Date();
  const trialEnd = subscription.trialEndsAt ? new Date(subscription.trialEndsAt) : null;
  
  if (!trialEnd) return null;

  const daysRemaining = Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  // Only show if less than 7 days remaining
  if (daysRemaining > 7) return null;

  // Determine severity
  const isUrgent = daysRemaining <= 3;
  const variant = isUrgent ? 'destructive' : 'default';

  return (
    <Alert variant={variant} className="mb-4">
      <Clock className="h-4 w-4" />
      <AlertTitle>
        {daysRemaining === 0 
          ? 'Trial Expires Today!' 
          : `${daysRemaining} ${daysRemaining === 1 ? 'Day' : 'Days'} Left in Trial`}
      </AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <span>
          Your trial ends on {trialEnd.toLocaleDateString()}. 
          {isUrgent ? ' Choose a plan to continue using Ripplefy.' : ' Upgrade now to avoid service interruption.'}
        </span>
        <Button 
          size="sm" 
          variant={isUrgent ? 'default' : 'outline'}
          className="ml-4"
        >
          <ArrowUpCircle className="h-4 w-4 mr-1" />
          Choose Plan
        </Button>
      </AlertDescription>
    </Alert>
  );
};
